import { render, staticRenderFns } from "./reportCover.vue?vue&type=template&id=72cacdbb&"
import script from "./reportCover.vue?vue&type=script&lang=js&"
export * from "./reportCover.vue?vue&type=script&lang=js&"
import style0 from "./reportCover.vue?vue&type=style&index=0&id=72cacdbb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports